import productsFieldsQuery from '../domain/types/graphql/fields/products'
import { gql } from './gql'

/**
 * Get's the string for `getProductBySku` query.
 * This query gets the data for a single product with a given SKU.
 */
export const GET_PRODUCT_BY_SKU = gql`
  query GetProductBySKU(
    $storefrontName: String!
    $sessionId: String!
    $sku: String!
  ) {
    getProductBySKU(
      storefrontName: $storefrontName
      sessionUid: $sessionId
      sku: $sku
    ) {
      ${productsFieldsQuery}
    }
  }
`
